"use client";
import React from "react";
import { FaWhatsapp } from "react-icons/fa";

const CommunitySection = () => {
  return (
    <section className="bg-[#f8fafc] py-20 px-4">
      <div className="container mx-auto max-w-6xl">
        <div className="relative overflow-hidden bg-slate-900 rounded-[2.5rem] p-8 md:p-16">
          {/* Background Decoration */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-blue-600/20 blur-[80px] rounded-full translate-x-1/2 -translate-y-1/2"></div>

          <div className="relative z-10 flex flex-col md:flex-row items-center justify-between gap-10">
            <div className="text-center md:text-left">
              <h3 className="text-3xl md:text-5xl font-bold text-white leading-tight mb-6">
                Ready to accelerate your <br />
                <span className="text-blue-400">technical growth?</span>
              </h3>
              <p className="text-slate-400 text-lg md:max-w-md">
                Join 5,000+ professionals in the Vidyastu community and get a free career consultation today.
              </p>
            </div>

            <div className="flex flex-col items-center gap-4">
              <a
                href="https://api.whatsapp.com/send/?phone=917450010203"
                target="_blank"
                className="group relative inline-flex items-center justify-center px-10 py-5 font-bold text-white transition-all duration-200 bg-blue-600 font-pj rounded-2xl focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-900 hover:bg-blue-500 shadow-[0_0_30px_rgba(37,99,235,0.3)]"
              >
                <FaWhatsapp className="mr-3 text-2xl" />
                JOIN COMMUNITY
              </a>
              <span className="text-slate-500 text-sm font-medium italic">
                * Free consultation ends this Friday
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CommunitySection;